require('./contractAresLoanStepINEModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
// @core
const { formatText } = require('core/i18n').i18n;
// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
// @components
const ContractLoanPdfViewerError = require('../../../contractLoanPdfViewerError/contractLoanPdfViewerError');
// @constants
const translations = require('./contractAresLoanINEModal.translations');
//@analytics
const { analyticsId, catalogue } = require( '../../analytics/contractAresLoanAnalytics' );
//@utilities
const { recordLinkV2, recordPathV2 } = require('utilities/tagging');

class ContractAresLoanINEModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            agreeINE: false,
            scrollFinalDone: false,
            viewerHeightModal: 'auto',
        };

        this.handleAgreeINE = this.handleAgreeINE.bind(this);
        this.getSize = this.getSize.bind(this);
        this.handleCancelModal = this.handleCancelModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleConfirmModal = this.handleConfirmModal.bind(this);
    }
    componentDidMount() {
        recordLinkV2(catalogue[analyticsId.OPEN_MODAL]());
    }

    componentWillReceiveProps(nextProps) {
        const { agreeCheckbox } = nextProps;
        this.setState({ agreeINE: agreeCheckbox, scrollFinalDone: agreeCheckbox });
    }

    componentDidUpdate(prevProps) {
        const { isOpenModal } = this.props;
        if (isOpenModal && prevProps.isOpenModal !== isOpenModal) {
            recordPathV2(catalogue[analyticsId.DISPLAY_DOC]());
        }
    }

    handleAgreeINE() {
        this.setState({ agreeINE: !this.state.agreeINE });
    }

    getSize(height) {
        this.setState({ viewerHeightModal: height - 64 });
    }

    buildContent() {
        const {
            immScreen, documents, isFetching, error,
            getDocuments, handleDownloadDocuments, handlePrintDocuments
        } = this.props;
        const { viewerHeightModal } = this.state;

        if (isFetching) {
            return <LoadingSection />;
        }

        return (
            <OKPdfViewer
                title={formatText(translations.PDF_VIEWER_TITLE)}
                pdfFile={documents && documents.body || ''}
                onDownload={handleDownloadDocuments}
                onPrint={handlePrintDocuments}
                displayScrollButton
                showScroll
                scale={immScreen && (immScreen.get('isTablet') || immScreen.get('isMobile')) ? 1.2 : 1.5}
                viewerHeight={viewerHeightModal}
                onDocumentReaded={() => this.setState({ scrollFinalDone: true })}
                failedLoadingPdf={error}
                errorComponent={() => {
                    return <ContractLoanPdfViewerError getDocuments={getDocuments} />
                }}
            />
        );
    }

    buildCheckboxContent() {
        const { agreeINE, scrollFinalDone } = this.state;

        return (
            <React.Fragment>
                {scrollFinalDone && (
                    <OKCheckbox
                        idName="checkbox-ine-viewer"
                        labelId="checkbox-ine-viewer"
                        label={formatText(translations.PDF_VIEWER_CHECKBOX)}
                        onChange={this.handleAgreeINE}
                        value={agreeINE}
                    />
                )}
            </React.Fragment>
        );
    }
    
    handleCloseModal() {
        this.props.onCloseModal();
        recordLinkV2(catalogue[analyticsId.EXIT_MODAL]());
    }

    handleCancelModal() {
        this.props.onCloseModal();
        recordLinkV2(catalogue[analyticsId.CANCEL_BUTTON]());
    }

    handleConfirmModal() {
        this.props.onCloseModal(true);
        recordLinkV2(catalogue[analyticsId.CONTINUE_BUTTON]());
    }

    render() {
        const { immScreen, isOpenModal } = this.props;
        const { agreeINE, scrollFinalDone } = this.state;

        const content = this.buildContent();
        const checkboxContent = this.buildCheckboxContent();
        return (
            <OKModal
                isOpen={isOpenModal}
                title={formatText(translations.MODAL_TITLE)}
                onCloseCallback={this.handleCloseModal}
                content={content}
                contentOverflow={'hidden'}
                footerType={'navigation'}
                contentFooter={checkboxContent}
                getSize={this.getSize}
                noContentScroll
                size={immScreen && (immScreen.get('isTablet') || immScreen.get('isMobile')) ? 'full-screen' : 'extra-large'}
                onPrimaryButtonClick={this.handleConfirmModal}
                primaryButtonText={formatText(translations.MODAL_CONTINUE_BUTTON)}
                primaryButtonDisabled={!agreeINE}
                onSecondaryButtonClick={this.handleCancelModal} 
                secondaryButtonText={formatText(translations.MODAL_CANCEL_BUTTON)}
                overlayClassName={`contract-ares-loan-ine-modal__${scrollFinalDone ? 'show' : 'hide'}-footer`}
            />
        );
        
    }
}

ContractAresLoanINEModal.propTypes = {
    // Modal
    isOpenModal: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    // INE info
    documents: PropTypes.object.isRequired,
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.object.isRequired,
    getDocuments: PropTypes.func.isRequred,
    handleDownloadDocuments: PropTypes.func.isRequred,
    handlePrintDocuments: PropTypes.func.isRequred,
    // agree
    agreeCheckbox: PropTypes.object.isRequired,
    // screen
    immScreen: PropTypes.object.isRequired,
};

module.exports = connect(state => ({ immScreen: state.screen, }), null)(ContractAresLoanINEModal);